import React from "react";
import { connect } from "react-redux";
import ThemeSelection from "./ThemeSelection";
import AssignmentPinsProvider from "components/Assignment/AssignmentPinsProvider";
import AssignmentPinsSelection from "./AssignmentPinsSelection";
import { userHasAnyRight } from "selectors/rights";
import { ASSIGN, ASSIGNMENTTOOLINSURANCE, ASSIGNMENTTOOLAPPRAISAL } from "typeConstants/rights";

interface AppearanceProps {
  // Redux
  showPinSelection: boolean;
}

const Appearance = (props: AppearanceProps) => {
  return (
    <div>
      <span>Theme</span>
      <ThemeSelection />
      {props.showPinSelection && <>
        <br />
        <span>Assignment Tool Pins</span>
        <AssignmentPinsProvider>
          <AssignmentPinsSelection />
        </AssignmentPinsProvider>
      </>} 
    </div>
  );
};

const mapStateToProps = state => ({
  showPinSelection: userHasAnyRight(ASSIGN, ASSIGNMENTTOOLINSURANCE, ASSIGNMENTTOOLAPPRAISAL)(state),
});

export default connect(mapStateToProps)(Appearance);